module.exports = __webpack_public_path__ + "img/ricardo-gomez-angel-SAJD-Q4FntE-unsplash.8a6941a3.jpg";